<template>
  <v-card class="mt-1">
    <v-row no-gutters>
      <v-col cols="12" class="pb-0 pt-1 pl-3" :style="estiloDerechos">
        <v-row>
          <v-col cols="10" class="pb-1 pt-1">
            <span v-if="numero !== 0" style="font-size: 1rem"> Obligación: {{ numero }} </span>
          </v-col>
          <v-col v-if="(estaPago)" cols="2" class="pb-1 pt-1">
            <v-tooltip content-class="top" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="mostrarInfoObligacion">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>Mostrar pagos</span>
            </v-tooltip>
          </v-col>
          <v-col v-else-if="(obligacion.condonada_sn)" cols="2" class="pb-1 pt-1">
            <v-tooltip content-class="top" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>Condonada</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="11" class="pb-0 pt-1 pl-3">
        <v-text-field v-model="inputVal" color="gold" :label="montoCantidad" type="number" step="0.01" :readonly="!esValorMonetario || estaPago" />
      </v-col>
      <v-col v-if="!condonada && (mode === 'new' || mode === 'edit')" cols="1" class="pb-0 pt-2 mr-0">
        <v-checkbox v-model="seleccionada" hide-details color="info" class="shrink mr-0 mt-0 pa-0" @change="select" />
      </v-col>
    </v-row>
    <v-col cols="12" class="pt-0">
      <v-menu ref="menuVencimiento" v-model="menuVencimiento" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
        <template v-slot:activator="{ on }">
          <v-text-field v-model="dateVal" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Vencimiento" readonly v-on="on" />
        </template>
        <v-date-picker v-model="dateVal" color="gold" landscape scrollable locale="es-419" no-title @input="menuVencimiento = false" />
      </v-menu>
    </v-col>
    <datosObligaciones :obligacion="obligacionInfo" :toggle="dialogObligacion" class="mr-0 mt-0 pa-0" style="display: inline" />
  </v-card>
</template>

<script>
  import datosObligaciones from '../components/InformacionObligacion'

  export default {
    name: 'Obligacion',
    components: {
      datosObligaciones,
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      fechaVencimiento: {
        type: String,
        default: '',
      },
      mode: {
        type: String,
        default: '',
      },
      esValorMonetario: {
        type: Boolean,
        default: false,
      },
      detalleId: {
        type: Number,
        default: 0,
      },
      condonada: {
        type: Boolean,
        default: false,
      },
      numero: {
        type: Number,
        default: 0,
      },
      pagosId: {
        type: Number,
        default: null,
      },
      valorMonetario: {
        type: Number,
        default: null,
      },
      obligacion: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialogObligacion: true,
        menuVencimiento: false,
        dateVal: this.fechaVencimiento,
        seleccionada: false,
        colorVerde: 'background-color: #ABFD99',
        colorAmarillo: 'background-color: #FDFD96',
        colorBlanco: 'color: "#ABFD99"',
        obligacionInfo: {
          moneda_id: 1,
        },
      }
    },
    computed: {
      estaPago () {
        return ((this.pagosId !== null) || (this.valorMonetario !== 0 && this.valorMonetario !== null))
      },
      inputVal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', parseFloat(val, 10))
        },
      },
      montoCantidad () {
        return (this.esValorMonetario) ? 'Monto' : 'Cantidad'
      },
      estiloDerechos () {
        if (this.estaPago) {
          return this.colorVerde
        }
        if (this.obligacion.condonada_sn) {
          return this.colorAmarillo
        }
        return this.colorBlanco
      },
    },
    watch: {
      dateVal (val) {
        this.dateVal = val
        this.$emit('inputDate', val)
      },
      fechaVencimiento (val) {
        this.dateVal = val
      },
    },
    methods: {
      select () {
        const datoAcccion = {
          id: this.detalleId,
          agregar: this.seleccionada,
        }
        this.$emit('selected', datoAcccion)
      },
      mostrarInfoObligacion () {
        this.obligacionInfo = this.obligacion
        this.dialogObligacion = !this.dialogObligacion
      },
    },
  }
</script>
